@if (searchResultsList) {
  <div class="search-result-data-wrapper">
    <div
      [class.left-section]="searchResultsList.results.length > 0"
      [class.no-data-section]="searchResultsList.results.length === 0"
    >
      @if (searchResultsList.results.length > 0) {
        <div class="all-section">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [checked]="allCheckboxChecked"
              [disabled]="
                searchResultsList.results.every(isVlfRowDisabled.bind(this))
              "
              (change)="onAllCheckBoxChange($event, searchResultsList.results)"
            />
            <span class="checkmark"></span>
            <span class="label-text">All</span>
          </label>
          @if (selectedCompanies.length > 0) {
            <div class="right-section-buttons">
              <a
                id="tour-custom-view-map"
                href="javascript:void(0)"
                (click)="onShowInMap()"
                class="show-in-map"
                >Show In Map</a
              >
              <!-- <div class="right-button-wrapper">
                    <div class="icap">
                      <span>ICAP</span>
                      <div class="arrow-down"></div>
                    </div>
                    <a href="javascript:void(0)" class="enquiry-form"
                      >Generate Inquiry Form</a
                    >
                  </div> -->
              @if (selectedTab !== "data-axle") {
                <a
                  href="javascript:void(0)"
                  (click)="hasUnassigned ? onAssignToMe() : null"
                  class="assign-to-me"
                  [class.disabled]="!hasUnassigned"
                  [attr.disabled]="!hasUnassigned ? true : null"
                  [attr.title]="
                    !hasUnassigned
                      ? 'Cannot assign companies that are already assigned to you or to the system'
                      : null
                  "
                  >Assign to Me</a
                >
              }
            </div>
          }
        </div>
      }
      <div [class.results-wrapper]="searchResultsList.results.length > 0">
        @for (
          company of searchResultsList.results;
          let i = $index;
          track company.unique_id
        ) {
          <div
            class="each-result"
            [class.vlf-disabled]="isVlfRowDisabled(company)"
            [id]="'tour-record-item-' + i"
            [title]="
              isVlfExpired(company)
                ? 'This lead has expired.'
                : isVlfClaimedByOtherOrg(company)
                  ? 'This lead has already been claimed by another organization.'
                  : ''
            "
          >
            <div class="checkbox-section">
              <label class="checkbox-container">
                <input
                  [id]="'tour-record-item-checkbox-' + i"
                  type="checkbox"
                  [disabled]="isVlfRowDisabled(company)"
                  [checked]="selectedCompanies.includes(company)"
                  (change)="onSelectCompany(company, $event)"
                />
                <span class="checkmark"></span>
              </label>
              <a
                href="javascript:void(0)"
                class="label-text"
                [class.vlf-claimed]="isVlfRowDisabled(company)"
                (click)="isVlfRowDisabled(company) ? null : viewDetail(company)"
                [id]="'tour-record-item-view-' + i"
              >
                <div class="name">{{ company.company_name }}</div>
                <div class="short_address">
                  {{ getFormatAddress(company.short_address) }}
                </div>
                <div class="created-date">
                  @if (selectedTab === "deeproots") {
                    @if (company.latest_submission_on_utc) {
                      <div class="date-row">
                        <span class="date-label">Last Submission:</span>
                        {{
                          company.latest_submission_on_utc | date: "mediumDate"
                        }}
                      </div>
                    }
                    @if (company.created_on_utc) {
                      <div class="date-row">
                        <span class="date-label">Created:</span>
                        {{ company.created_on_utc | date: "mediumDate" }}
                      </div>
                    }
                  } @else {
                    @if (company.created_on_utc) {
                      <div class="date-row">
                        <span class="date-label">Created:</span>
                        {{ company.created_on_utc | date: "mediumDate" }}
                      </div>
                    }
                  }
                </div>
                @if (isSearchPage) {
                  <div
                    class="source-name"
                    [class.custom]="company.source === 'CUSTOM'"
                    [class.public]="company.source === 'PUBLIC'"
                    [class.wncsbi]="
                      company.source === 'CRF' ||
                      company.source === 'WNCSBI_APPS'
                    "
                  >
                    {{ getSourceName(company.source) }}
                  </div>
                }
                @if (company.source === "VLF") {
                  @if (isVlfFunded(company)) {
                    <div class="vlf-expiry-badge funded">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      Funded
                    </div>
                  } @else if (isVlfClaimedByOtherOrg(company)) {
                    <div class="vlf-expiry-badge claimed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <rect
                          x="3"
                          y="11"
                          width="18"
                          height="11"
                          rx="2"
                          ry="2"
                        />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                      Claimed
                    </div>
                  } @else {
                    @let expiry = getVlfExpiresIn(company);
                    <div
                      class="vlf-expiry-badge"
                      [class.urgent]="expiry.urgent"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      {{ expiry.label }}
                    </div>
                  }
                }
              </a>
            </div>
            <div class="creator-tag-wrapper">
              @if (
                company.created_by_user?.username ===
                  loggedInUserInfo?.username && company.source === "CUSTOM"
              ) {
                <div
                  class="creator-tag"
                  [id]="'tour-custom-record-creator-' + i"
                >
                  Creator
                </div>
              }
            </div>
            <div class="creator-tag-wrapper">
              @if (
                company.visibility_mode &&
                company.visibility_mode !== recordVisibilityModes.Public
              ) {
                <div
                  class="creator-tag visibility-mode"
                  [id]="'tour-record-visibility-' + i"
                >
                  @if (
                    company.visibility_mode === recordVisibilityModes.Private
                  ) {
                    <app-svg-icon
                      [iconName]="'private-lock.svg'"
                      [width]="'16px'"
                      [height]="'16px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                    <span>Private</span>
                  } @else {
                    <app-svg-icon
                      [iconName]="'restricted-users.svg'"
                      [width]="'16px'"
                      [height]="'16px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                    <span>Restricted</span>
                  }
                </div>
              }
            </div>
            <div
              class="right-end"
              [class.vlf-claimed]="isVlfRowDisabled(company)"
              (click)="isVlfRowDisabled(company) ? null : viewDetail(company)"
              (keydown.enter)="
                isVlfRowDisabled(company) ? null : viewDetail(company)
              "
              tabindex="0"
            >
              @if (company.assignees && company.assignees.length > 0) {
                <div class="assigned-to" [id]="'tour-record-assigned-to-' + i">
                  <span class="assignedto-text">Assigned to</span>
                  <div class="assignee-badges-container">
                    @for (
                      badge of getAssigneeBadges(company);
                      track badge.name
                    ) {
                      <div
                        class="assignee-badge has-tooltip"
                        [class.current-user]="
                          badge.isCurrentUser && badge.cdfi_logo_path === null
                        "
                        [class.has-image]="badge.cdfi_logo_path !== null"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="$event.stopPropagation()"
                        tabindex="0"
                      >
                        @if (badge.cdfi_logo_path === null) {
                          <span class="badge-initial">
                            {{ badge.initial }}
                          </span>
                        } @else {
                          <img
                            [src]="badge.cdfi_logo_path"
                            alt="Profile"
                            class="badge-image visible"
                          />
                        }
                        <div class="tooltip">
                          <div class="arrow-down"></div>
                          <div class="assignee-name">
                            {{ badge.name }}
                          </div>
                          @if (badge.assignedDate) {
                            <div class="assigned-date">
                              Assigned On:
                              {{ badge.assignedDate | date: "medium" }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (getExtraAssigneesCount(company) > 0) {
                      <div class="assignee-badge extra-count has-tooltip">
                        +{{ getExtraAssigneesCount(company) }}
                        <div
                          class="tooltip extra-assignees-tooltip"
                          role="tooltip"
                        >
                          <div class="arrow-down"></div>
                          @for (
                            assignee of getExtraAssignees(company);
                            track assignee.connection_name
                          ) {
                            <div class="assignee-item">
                              <div class="assignee-name">
                                {{
                                  assignee.display_name ||
                                    assignee.connection_name
                                }}
                              </div>
                              @if (assignee.assigned_on_utc) {
                                <div class="assigned-date">
                                  Assigned On:
                                  {{
                                    assignee.assigned_on_utc | date: "medium"
                                  }}
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (!isVlfRowDisabled(company)) {
                <div class="right-arrow-wrapper">
                  <a
                    href="javascript:void(0)"
                    class="right-arrow"
                    (click)="viewDetail(company)"
                  >
                  </a>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (searchResultsList.results.length > 0) {
        <div class="pagination">
          <a
            href="javascript:void(0)"
            (click)="onPageChange(currentPage - 1)"
            [class.disabled]="currentPage === 1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
              />
            </svg>
            <span>Previous</span>
          </a>
          <span>Page {{ currentPage }} of {{ totalPages }}</span>
          <a
            href="javascript:void(0)"
            (click)="onPageChange(currentPage + 1)"
            [class.disabled]="currentPage >= totalPages"
          >
            <span>Next</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path
                d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5 12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
              />
            </svg>
          </a>
        </div>
      }
    </div>
  </div>
}

@if (isRecordDetailsPopupOpen) {
  <app-record-details
    [company]="company"
    (assignedLead)="OnLeadAssign($event)"
    (popupClosed)="closeRecordDetailsPopup()"
    (companyDeleted)="onCompanyDeleted($event)"
    (companyDetailsUpdated)="onCompanyDetailsUpdated($event)"
    (triggerSearchResults)="refreshSearchResults($event)"
  ></app-record-details>
}
